import { css } from 'react-emotion'

const styles = {
  component: css({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px',
    border: '1px solid #e6e6e6'
  }),
  column: css({
    flex: 1
  }),
  status: css({
    minWidth: '150px'
  }),
  version: css({
    textAlign: 'center',
    flex: 1,
  }),
  download: css({
    flex: 1,
    textAlign: 'right'
  })
}

export default styles



// WEBPACK FOOTER //
// ./src/Components/VideoPlayer/ToolBar/ToolBarStyles.js